import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import {
	type OptimisticUiMeta,
	type OptimisticUiMetaWithFlag,
	beginOptimisticUiMeta,
	commitOptimisticUiMeta,
	revertOptimisticUiWithFlagMeta,
} from '../../meta/optimistic-ui-meta';

export const SPRINT_DELETE_REQUEST = 'state.actions.sprints.delete.SPRINT_DELETE_REQUEST' as const;

type SprintDeleteRequestPayload = {
	sprintId: string;
	nextCardListId: string | null;
};

export type SprintDeleteRequestAction = {
	type: typeof SPRINT_DELETE_REQUEST;
	payload: SprintDeleteRequestPayload;
	meta: OptimisticUiMeta & {
		analyticsEvent: UIAnalyticsEvent;
	};
};

export const sprintDeleteRequest = (
	sprintId: string,
	nextCardListId: string | null,
	analyticsEvent: UIAnalyticsEvent,
): SprintDeleteRequestAction => ({
	type: SPRINT_DELETE_REQUEST,
	payload: {
		sprintId,
		nextCardListId,
	},
	meta: {
		...beginOptimisticUiMeta(),
		analyticsEvent,
	},
});

export const SPRINT_DELETE_SUCCESS = 'state.actions.sprints.delete.SPRINT_DELETE_SUCCESS' as const;

export type SprintDeleteSuccessAction = {
	type: typeof SPRINT_DELETE_SUCCESS;
	payload: {
		sprintId: string;
	};
	meta: OptimisticUiMeta;
};

export const sprintDeleteSuccess = (
	sprintId: string,
	optimisticId: string,
): SprintDeleteSuccessAction => ({
	type: SPRINT_DELETE_SUCCESS,
	payload: { sprintId },
	meta: commitOptimisticUiMeta(optimisticId),
});

export const SPRINT_DELETE_FAILURE = 'state.actions.sprints.delete.SPRINT_DELETE_FAILURE' as const;

export type SprintDeleteFailureAction = {
	type: typeof SPRINT_DELETE_FAILURE;
	payload: {
		sprintId: string;
	};
	meta: OptimisticUiMetaWithFlag;
};

export const sprintDeleteFailure = (
	sprintId: string,
	optimisticId: string,
): SprintDeleteFailureAction => ({
	type: SPRINT_DELETE_FAILURE,
	payload: { sprintId },
	meta: revertOptimisticUiWithFlagMeta(optimisticId),
});

export type Action =
	| SprintDeleteRequestAction
	| SprintDeleteSuccessAction
	| SprintDeleteFailureAction;
